<template>
  <el-dialog
    v-drag
    title="审核"
    :visible.sync="dialogVisible"
    width="600px"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    append-to-body
    :before-close="cancel"
    top="3%"
  >
    <el-form
      ref="form"
      :model="form"
      :rules="rules"
      label-position="top"
      label-width="80px"
    >
      <el-form-item label="水单图片">
        <img
          class="imgbox"
          :src="rowData.systemFilePath"
          @click="open"
        />
      </el-form-item>
      <el-form-item v-if="rowData.bankCurrency != rowData.companyCurrency && typeActive === 0" label="汇率处理类型" prop="exchangeRateHandType">
        <el-radio-group v-model="form.exchangeRateHandType">
          <el-radio :label="0">{{rowData.bankCurrency}} 换算成 {{ rowData.companyCurrency }} </el-radio> <!-- 乘-->
          <el-radio :label="1">{{ rowData.companyCurrency }} 换算成 {{rowData.bankCurrency}} </el-radio> <!-- 除-->
        </el-radio-group>
      </el-form-item>
      <el-form-item label="汇率" prop="exchangeRate">
        <el-input-number
          v-model="form.exchangeRate"
          style="width: 100%"
          controls-position="right"
          :min="0.01"
          :precision="4"
          :step="1"
          :disabled="rowData.bankCurrency === rowData.companyCurrency"
        >
        </el-input-number>
      </el-form-item>
      <!-- 是否发送邮件通知 -->
      <el-form-item label="是否通过" prop="status">
        <el-radio-group v-model="form.status">
          <el-radio :label="1">通过</el-radio>
          <el-radio :label="-1">不通过</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item
        v-if="form.status === -1"
        label="不通过原因"
        prop="description"
      >
        <base-select-common
          ref="baseSelectCommon"
          v-model="form.description"
          :type="16"
          title="原因"
        ></base-select-common>
      </el-form-item>
      <el-form-item label="是否发送邮件通知" prop="isSendEmail">
        <el-radio-group v-model="form.isSendEmail">
          <el-radio :label="true">是</el-radio>
          <el-radio :label="false">否</el-radio>
        </el-radio-group>
      </el-form-item>
    </el-form>
    <span slot="footer" class="footers">
      <div class="cancel flex_c_c" @click="cancel">取 消</div>
      <div v-loading="loding" class="ok flex_c_c" @click="ok('form')">
        确 定
      </div>
    </span>
  </el-dialog>
</template>
<script>
import { approval } from '@/api/client'
import { approvalBySupplier } from '@/api/supplierPayment'
import config from '@/utils/config'
const BaseSelectCommon = () => import('@/components/base/BaseSelectCommon.vue')
export default {
  components: { BaseSelectCommon },
  props: {
    dialogVisible: {
      type: Boolean,
      default: false
    },
    billId: {
      type: String,
      default: ''
    },
    typeActive: {
      type: Number,
      default: 0
    },
    rowData: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      config,
      form: {
        status: 1,
        description: '',
        exchangeRateHandType: 0,
        exchangeRate: 1,
        isSendEmail: true
      },
      rules: {
        status: [{ required: true }],
        isSendEmail: [{ required: true }],
        description: [
          { required: true, message: '请输入不通过原因', trigger: 'change' }
        ],
        exchangeRate: [
          { required: true, message: '请输入税率', trigger: 'blur' }
        ]
      },
      loding: false
    }
  },
  methods: {
    cancel() {
      this.$emit('cancel')
    },
    open() {
      window.open(this.rowData.systemFilePath)
    },
    ok(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.loding = true
          let description = this.form.description
          if (description) {
            description =
              this.$refs.baseSelectCommon?.getValueLable(description)
          }

          if (!this.typeActive) {
            if (this.form.exchangeRateHandType === 0 && this.form.exchangeRate > 1) {
              this.$message.error(`汇率处理类型为 ${this.rowData.bankCurrency} 换算成 ${this.rowData.companyCurrency} 时，汇率不能大于1`)
              this.loding = false
              return
            }
            if (this.form.exchangeRateHandType === 1 && this.form.exchangeRate < 1) {
              this.$message.error(`汇率处理类型为 ${this.rowData.companyCurrency} 换算成 ${this.rowData.bankCurrency} 时，汇率不能小于1`)
              this.loding = false
              return
            }

            approval({
              ...this.form,
              description,
              id: this.rowData.id
            }).then((res) => {
              this.loding = false
              if (res.success) {
                this.$message.success('操作成功')
                this.$emit('ok')
              } else {
                this.$message.error(res.errorMessage)
              }
            })
          } else {
            approvalBySupplier({
              ...this.form,
              description,
              id: this.rowData.id
            }).then((res) => {
              this.loding = false
              if (res.success) {
                this.$message.success('操作成功')
                this.$emit('ok')
              } else {
                this.$message.error(res.errorMessage)
              }
            })
          }
        }
      })
    }
  }
}
</script>
<style lang="less" scoped>
.imgbox {
  width: 100%;
  height: 310px;
  object-fit: contain;
}
.footers {
  display: flex;
  justify-content: center;
  .cancel {
    width: 120px;
    height: 40px;
    background: #eeeeee;
    border-radius: 4px 4px 4px 4px;
    font-size: 14px;
    font-family: Microsoft YaHei-Regular, Microsoft YaHei;
    font-weight: 400;
    color: #999999;
    margin-right: 16px;
    cursor: pointer;
  }
  .ok {
    width: 120px;
    height: 40px;
    background: rgb(18, 88, 188);
    border-radius: 4px 4px 4px 4px;
    font-size: 14px;
    cursor: pointer;
    font-family: Microsoft YaHei-Regular, Microsoft YaHei;
    font-weight: 400;
    color: #ffffff;
  }
}
</style>
